module.exports = __webpack_public_path__ + "media/images/general/logo-sm-306885404dd964e40fec69e6c0088337.svg";